import type { AxiosInstance } from 'axios';
import type { Branding } from './interfaces/groups.js';
import type * as Groups from './interfaces/groups.js';

export type CreateGroupPaletteRequest = {
  groupId: number;
  name: string;
  data: { colors: string[] };
  categoryId: number;
};

export type CreateGroupPaletteResponse = {
  palette: {
    id: number;
    name: string;
    data: { colors: string[] };
    categoryId: number;
    typeId: number;
  };
};

export class GroupsClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  getGroupUsers = (data: Groups.GetGroupUsers.Request): Promise<Groups.GetGroupUsers.Response> => {
    return this.authenticatedClient
      .get<Groups.GetGroupUsers.Response>(`/groups/users`, { params: data })
      .then((res) => res.data);
  };

  fetchBranding = (data: Branding.FetchBranding.Request) => {
    return this.authenticatedClient
      .get<Branding.FetchBranding.Response>(`/groups/${data.groupId}/branding`)
      .then((res) => res.data);
  };

  createGroupPalette = (data: CreateGroupPaletteRequest): Promise<CreateGroupPaletteResponse> => {
    const { groupId, ...body } = data;
    return this.authenticatedClient
      .post<CreateGroupPaletteResponse>(`/groups/${groupId}/branding/palettes`, body)
      .then((res) => res.data);
  };
}
